import React from "react";

import { useAppDispatch, useAppSelector } from "store";
import { selectSelectedStoreByCostType } from "modules/customer/insights/cost/costSlice";
import { showFilters } from "modules/customer/insights/cost/filters/filtersSlice";
import { loadCostActions, ClearStoreCostActions } from "modules/customer/insights/cost/storeCostActions/storeCostActionsSlice";

import Chapter from "pages/customer/tools/product/insight/Chapter";
import Subchapter from "pages/customer/tools/product/insight/Subchapter";

import CostActions from "./costActions/CostActions";

const StoreCostActions: React.FC = () => {
    const dispatch = useAppDispatch();
    const store = useAppSelector(selectSelectedStoreByCostType);

    React.useEffect(() => {
        if (!store) {
            dispatch(showFilters());
        }
    }, [dispatch, store]);

    React.useEffect(() => {
        if (store) {
            dispatch(loadCostActions());
        }
        return () => {
            dispatch(ClearStoreCostActions());
        };
    }, [dispatch, store]);

    if (!store) {
        return null;
    }

    return (
        <Chapter
            title="Store cost actions"
            subtitle={`Explore the factors that influence your ${store?.storeName} ${store?.costName} cost. Identify which actions have the greatest impact on ${store?.costName} costs and empower store managers to take targeted actions that unlocks cost saving values.`}
            dataCy="store-cost-actions-chapter"
        >
            <Subchapter
                title={`${store?.storeName} ${store?.costName} cost actions`}
                subtitle={`For your ${store?.storeName} store, explore all Cost actions and see how each one compares to both the cluster average and your target benchmarks - helping you identify where action is needed most.`}
                dataCy="store-cost-actions-subchapter"
            >
                <CostActions />
            </Subchapter>
        </Chapter>
    );
};

export default StoreCostActions;
